/** Standard base rate for non-dynamic pricing — mirrors backend BASE_RATE_CENTS */
export const BASE_RATE_CENTS = 2800; // $28/hr

/** Dynamic one-time cleaning floor — mirrors backend ONETIME_CLEANING_FLOOR_CENTS */
export const ONETIME_CLEANING_FLOOR_CENTS = 1600; // $16/hr

/**
 * Lowest advertised General Cleaning rate, for "from $X/hr" marketing copy.
 *
 * Derived from the dynamic floor rather than hardcoded, so hero/FAQ/service-page copy
 * cannot drift from what the booking flow actually charges. Before dynamic pricing this
 * was $25 (the recurring rate, then the cheapest option); one-time off-peak is now lower.
 *
 * Recurring is a flat $25/hr and is NOT dynamic — do not use this for recurring copy.
 */
export const ONETIME_FROM_RATE_DOLLARS = ONETIME_CLEANING_FLOOR_CENTS / 100;
export const ONETIME_FROM_RATE_LABEL = `$${ONETIME_FROM_RATE_DOLLARS}/hr`;

/** Price lock TTL in seconds — mirrors backend PRICE_LOCK_TTL_SECONDS */
export const PRICE_LOCK_DURATION_SECONDS = 900; // 15 minutes



// General cleaning — one-time rate ($/hr), keyed by session duration.
// Matches BASE_RATE_CENTS / calculateGeneralCleaningPrice, which is what
// one-time bookings are actually charged.
export const GENERAL_CLEANING_ONE_TIME_RATES = {
  3: BASE_RATE_CENTS / 100,
  4: BASE_RATE_CENTS / 100,
} as const;

// General cleaning — weekly rate ($/hr), keyed by session duration
export const GENERAL_CLEANING_WEEKLY_RATES = {
  3: 25,
  4: 25,
} as const;

// General cleaning — fortnightly rate ($/hr), keyed by session duration
export const GENERAL_CLEANING_FORTNIGHTLY_RATES = {
  3: 25,
  4: 25,
} as const;

// ─── Dynamic Pricing ────────────────────────────────────────────────────────
// Mirrors backend/constants/dynamicPricing.js — display metadata only.
// Score ranges are for reference; the backend is the source of truth for pricing.

export const PRICING_TIERS = {
  off_peak:   { label: "Low demand",   color: "#166f3c", order: 0, scoreMin: 0,  scoreMax: 35  },
  normal:     { label: "Standard",     color: "#2cb96a", order: 1, scoreMin: 36, scoreMax: 60  },
  peak:       { label: "High demand",  color: "#d4a017", order: 2, scoreMin: 61, scoreMax: 85  },
  super_peak: { label: "Peak pricing", color: "#dc2626", order: 3, scoreMin: 86, scoreMax: 100 },
} as const;

export type PricingTier = keyof typeof PRICING_TIERS;

export type DynamicPricingTier = {
  label: string;
  color: string;
  order: number;
  scoreMin: number;
  scoreMax: number;
};

